import React from 'react'
import Slider from '@mui/material/Slider';
function SliderMui({defaultValueMin, defaultValueMax,minValue, maxValue,step, handleChangeValue}) {
    
    return (
        <Slider
            defaultValue={[defaultValueMin, defaultValueMax]}
            step={step}
            min={minValue}
            max={maxValue}
            onChange={handleChangeValue}
            valueLabelDisplay="auto"
            color="secondary"
        />)
}
export default SliderMui
